export default "__VITE_ASSET__Dm521bnQ__"